import React from "react";
import { whatsAppSimple } from "../lib/api";
import { useI18n } from "../i18n/LanguageContext";

const WhatsAppIcon = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c0-5.445 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.445-4.437 9.885-9.881 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.359.101 11.945c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652a11.93 11.93 0 005.71 1.446h.005c6.585 0 11.946-5.359 11.949-11.945a11.9 11.9 0 00-3.479-8.4" />
  </svg>
);

export const WhatsAppButton = () => {
  const { t } = useI18n();
  return (
    <a
      href={whatsAppSimple()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 md:bottom-8 right-5 z-40 group flex items-center gap-3"
      aria-label={t("common.whatsapp")}
      data-testid="whatsapp-float-button"
    >
      <span className="hidden md:block bg-vm-surface border border-vm-border text-vm-text2 text-xs tracking-wide px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        {t("common.whatsapp")}
      </span>
      <span className="w-14 h-14 rounded-full bg-vm-accent text-vm-bg flex items-center justify-center shadow-lg hover:scale-105 transition-transform duration-300">
        <WhatsAppIcon />
      </span>
    </a>
  );
};
